import { render, staticRenderFns } from "./userReferences.vue?vue&type=template&id=3a123628"
import script from "./userReferences.vue?vue&type=script&lang=js"
export * from "./userReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports